import { useSearchParams } from "next/navigation";

const useQueryFilterValues = (filterName: string): string[] => {
  const searchParams = useSearchParams();

  const filterKey = `filter[${filterName}]`;
  // * Due to our usage of leaflyShopStringify, search param values might appear as arrays with bracketed syntax.
  // * If/when we deprecate our usage of bracketed query string parameters on the frontend, the below logic can also be deprecated.
  const bracketedQSKey = `${filterKey}[]`;
  if (searchParams) {
    if (searchParams.getAll(filterKey).length > 0) {
      return searchParams.getAll(filterKey);
    }
    if (searchParams.getAll(bracketedQSKey).length > 0) {
      return searchParams.getAll(bracketedQSKey);
    }
  }

  return [];
};

export default useQueryFilterValues;
